
import { Component, Prop, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import Tiptop from "@/components/headers/tiptop.vue";
import LanguageList from "@/components/language-list.vue";
import ChangePassword from "@/views/setting/user/change-password.vue";
import breadcrumbNav from "@/components/breadcrumb-nav.vue";
import AppConsts from "@/lib/appConst";

@Component({
  components: { Tiptop, LanguageList, ChangePassword, breadcrumbNav },
})
export default class Header extends AbpBase {
  @Prop({ type: Boolean, default: false }) showKeywords: Boolean;
  @Prop({ type: Boolean, default: false }) hideBreadcrumb: Boolean;

  changePasswordModalShow: Boolean = false;
  keyword: string = "";
  keywords: Array<string> = (!this.tenant.tags ? [] : this.tenant.tags.split('#'))
  colorfulKeywords: Array<string> = [];

  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get user() {
    var user = {
      name: "",
      surname: "",
      userName: "",
    };
    return this.$store.state.session.user
      ? this.$store.state.session.user
      : user;
  }

  get userProfile() {
    if (this.$store.state.session.userProfile) {
      return this.$store.state.session.userProfile;
    } else {
      return {};
    }
  }

  get avatar() {
    let avatar = this.userProfile.avatarImageUrl;

    if (!avatar) {
      return AppConsts.user.avatar;
    }

    return avatar;
  }

  get isAuthorized() {
    return !!Util.abp.auth.getToken();
  }

  get loginUrl() {
    localStorage.setItem("LoginReturnUrl", location.href);
    return "/pc/home";
  }

  get isEnabledVipCard() {
    return Util.abp.features.isEnabled("VipCard");
  }

  get isEnabledRechargeCard() {
    return Util.abp.features.isEnabled("RechargeCard");
  }

  created() {
    if (this.$route.query.q) {
      this.keyword = this.$route.query.q.toString();
    }

    this.colourKeywords();
  }

  handleKeywordKeyDown(e) {
    if (e.charCode === 13) {
      this.handleClickSearch();
    }
  }

  handleClickSearch() {
    if (!this.keyword) {
      this.$router.push("/search");
    }
    this.$router.push("/search?q=" + this.keyword);
  }

  handleClickSearchByImage() {
    localStorage.setItem("SEARCH_BY_IMAGE", null);
    window.location.href = "/search-by-image";
  }

  handleClickHeaderNavItem(routeName: string) {
    this.$router.push({
      name: routeName,
    });
  }

  handleClickAvatar() {
    this.$router.push("/pc/home");
  }

  handleClickLogout() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("LogoutConfirm"),
      onOk: () => {
        this.$store.commit("app/logout")
      },
    });
  }

  colourKeywords() {
    for (var i = 0; i < 2; i++) {
      let random = Math.floor(Math.random() * 10);
      if (random > this.keywords.length - 1) {
        random = this.keywords.length - 1;
      }
      if (this.colorfulKeywords.indexOf(this.keywords[random]) < 0) {
        this.colorfulKeywords.push(this.keywords[random]);
      }
    }
  }
}
